import { format } from 'date-fns'
import { AddToCalendar } from 'src/modules/booking/components/add-to-calendar'
import { BookingThemedRoot } from 'src/modules/booking/components/booking-themed-root'
import { PoweredBy } from 'src/modules/booking/components/powered-by'
import { Icon, Typography } from 'src/modules/core/components'

import { BookingDetailsHeader } from './booking-details-header'
import { useBookingDetails } from './use-booking-details'

import classes from './booking-details.module.scss'

export function BookingDetails() {
  const f = useBookingDetails()

  if (!f.isLoading && f.hasError) {
    return (
      <div className={classes.root}>
        <div className={classes.container}>
          <div className={classes.errorCard}>
            <div className={classes.errorIcon}>
              <Icon name="error" />
            </div>
            <Typography variant="h1" className={classes.errorTitle}>
              Unable to locate booking
            </Typography>
            <Typography variant="body" className={classes.errorMessage}>
              This link may be expired, incorrect, or the appointment has been cancelled. Please check the link or
              contact the provider.
            </Typography>
          </div>
          <PoweredBy className={classes.poweredBy} />
        </div>
      </div>
    )
  }

  return (
    <BookingThemedRoot providerId={f.providerId} className={classes.root}>
      <div className={classes.container}>
        {f.isLoading ? (
          <div className={classes.card}>
            <div className={classes.loadingMessage}>
              <Typography variant="body">Loading booking details...</Typography>
            </div>
          </div>
        ) : (
          <div className={classes.card}>
            <BookingDetailsHeader providerName={f.data.providerName} logoUrl={f.data.logoUrl} />

            {f.showAppointmentDetails && (
              <div className={classes.detailsBox}>
                {f.data.appointmentType && (
                  <div className={classes.detailItem}>
                    <Typography variant="body" className={classes.detailText}>
                      {f.data.appointmentType.name} ({f.data.appointmentType.duration_minutes} min)
                    </Typography>
                  </div>
                )}
                <div className={classes.detailItem}>
                  <Icon name="calendarAlt" className={classes.detailIcon} />
                  <Typography variant="body" className={classes.detailText}>
                    {format(f.data.displayData.selectedDate!, 'EEEE, MMMM d')}
                  </Typography>
                </div>
                <div className={classes.detailItem}>
                  <Icon name="clock" className={classes.detailIcon} />
                  <Typography variant="body" className={classes.detailText}>
                    {f.data.timeRangeLabel}
                  </Typography>
                </div>
              </div>
            )}

            <AddToCalendar calendarEventData={f.data.calendarEventData} />

            {f.showRescheduleButton && (
              <>
                <hr className={classes.divider} />
                <button type="button" className={classes.rescheduleButton} onClick={f.handleRescheduleClick}>
                  Reschedule appointment
                </button>
              </>
            )}
          </div>
        )}
        <PoweredBy className={classes.poweredBy} />
      </div>
    </BookingThemedRoot>
  )
}
